import { Form, Link } from 'react-router-dom';
import Field from './form/Field.jsx'
import Button from './Button.jsx'


export default function FormUpdateUser({responseData, isSubmitting, userName}) {
  function nameHasError(responseData) {
    if (responseData && responseData.errors && responseData.errors.detail) {
      return "Nome inválido."
    }

    return ""
  }

  return (
    <div className="w-full bg-white rounded-lg shadow md:mt-0 sm:max-w-md xl:p-0">
      <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
        <Form method="PUT" className="space-y-4 md:space-y-6">

          <Field type={"input"} name={"name"} id={"name"} label={"Nome"} required={""} maxLength={50} defaultValue={userName} error={nameHasError(responseData)} />

          <Button styleName="green" className="w-full" disabled={isSubmitting}>
            {isSubmitting ? 'Salvando...' : 'Salvar'}
          </Button>

          <div className="text-center text-sm">
            <Link className="font-medium text-green-600 hover:underline" to={"/"}>Cancelar</Link>
          </div>
        </Form>
      </div>
    </div>
  )
}